import classNames from "classnames/dedupe";
import React, { FC } from "react";
import { formatters } from "../../../helpers";

export interface IPageTitleProps {
  title: string;
  productCount?: number;
  classes?: { root?: string };
}

const PageTitle: FC<IPageTitleProps> = (props) => {
  const { title, productCount = null, classes } = props;

  const rootClasses = classNames(classes?.root, "uds-page-title", {
    "uds-page-title__with-dot": !productCount,
  });

  return (
    <div className={rootClasses}>
      <h1 className="h-page">{title}</h1>
      <span className="uds-page-title--numbers">
        {formatters.commasToSpace(productCount)}
      </span>
    </div>
  );
};

export default PageTitle;
